import React from 'react';
import {useSelector} from 'react-redux';
import Tooltip from 'app/Components/Shared/Tooltip/Tooltip';
import {buildProductDescriptionParts} from '../utils/productDescriptionUtils';
import Image from 'app/Components/Shared/Image/image';

const infoIcon = require('../images/tooltip-i.svg');

/**
 * Renders product description with optional cellular phone(s).
 * Cellular data is read from selfcarePage.subscribersByProduct at render time.
 * @param {boolean} [showTooltip] - When set, overrides tooltip visibility from buildProductDescriptionParts.
 */
const ProductDescription = ({
  productDescriptions,
  banNumber,
  className = '',
  tooltipIdPrefix = 'product-desc',
  showTooltip: showTooltipFromParent,
}) => {
  const subscribersByProduct = useSelector((state) => state.selfcarePage?.subscribersByProduct);
  const {
    baseText,
    cellularText,
    phoneNumbers,
    showTooltip: showTooltipFromParts,
    layout,
  } = buildProductDescriptionParts(productDescriptions, banNumber, subscribersByProduct);
  const showTooltip = showTooltipFromParent ?? showTooltipFromParts;

  if (!baseText && !cellularText) {
    return null;
  }

  const tooltipTargetId = `${tooltipIdPrefix}-cellular-${banNumber}`;
  const tooltipText = phoneNumbers.join('\n');
  const showSeparator = layout === 'with-base' && baseText && cellularText;

  const cellularBlock = cellularText && (
    <span className='product-description__cellular'>
      <span className='product-description__cellular-text'>{cellularText}</span>
      {showTooltip && (
        <>
          <span
            id={tooltipTargetId}
            className='product-description__info-icon-wrapper'
            role='button'
            tabIndex={0}
          >
            <Image className='product-description__info-icon' src={infoIcon} alt='' />
          </span>
          <Tooltip
            title=''
            text={tooltipText}
            target={tooltipTargetId}
            placement='top'
            trigger='click'
            cellcomdefault={true}
            showCloseButton={true}
            additionalClassName='product-description-cellular-tooltip'
            onClose={() => document.getElementById(tooltipTargetId)?.click()}
          />
        </>
      )}
    </span>
  );

  if (layout === 'only-cellular' && cellularText) {
    return <span className={`product-description ${className}`.trim()}>{cellularBlock}</span>;
  }

  return (
    <span className={`product-description ${className}`.trim()}>
      {baseText && <span className='product-description__base'>{baseText}</span>}
      {showSeparator && <span className='product-description__separator'> | </span>}
      {cellularBlock}
    </span>
  );
};

export default ProductDescription;
